import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "../constants";

export default function RecalculMoyenneTrames({ motor, token }) {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" ou "error"

  const handleRecalcul = async () => {
    setIsLoading(true);
    setMessage("");
    setMessageType("");

    try {
      const response = await axios.post(
        `${API_URL}/trameshisto/recalcul?id=${motor._id}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      if (response.status === 200) {
        setMessage("Recalcul de la moyenne des trames effectué avec succès !");
        setMessageType("success");
      } else {
        setMessage("Une erreur est survenue lors du recalcul.");
        setMessageType("error");
      }
    } catch (error) {
      console.error("Erreur lors du recalcul:", error);
      
      // Afficher le message d'erreur de l'API (ex: code 400)
      if (error.response?.status === 400 && error.response?.data?.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage(
          error.response?.data?.message || 
          "Erreur lors du recalcul de la moyenne des trames."
        );
      }
      setMessageType("error");
    } finally {
      setIsLoading(false);
      // Efface le message après 5 secondes
      setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 5000);
    }
  };

  return (
    <div className="border-solid border-4 border-t-0 border-r-0 border-l-0 border-bleuSTB pt-4 pb-4">
        <h4 className="border-solid border-4 border-b-0  border-r-0 border-l-0 border-bleuSTB pt-4 text-xl 3xl:text-3xl underline"></h4>
      <h4 className="text-xl 3xl:text-3xl underline font-bold mb-4">
        Recalcul de la valeur moyenne vibratoire des trames (30 jours)
      </h4>
      
      <button
        onClick={handleRecalcul}
        disabled={isLoading}
        className={`bg-bleuSTB text-white px-3 py-1.5 rounded mb-2 text-sm sm:text-base ${
          isLoading ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        {isLoading ? "Recalcul en cours..." : "Recalculer la moyenne"}
      </button>

      {message && (
        <div
          className={`mt-4 p-3 rounded-lg text-base ${
            messageType === "success"
              ? "bg-green-100 text-green-800 border border-green-300"
              : "bg-red-100 text-red-800 border border-red-300"
          }`}
        >
          {message}
        </div>
      )}
    </div>
  );
}